import { Trash2 } from "lucide-react";

const OUTLINE = "M50 27 C44 27 42 30 41 33 C36 35 28 37 25 41 C21 46 19 55 18 65 C17 76 15 90 14 100 L22 102 C24 92 26 80 28 70 L30 60 L30 85 C30 100 31 112 33 124 C34 140 35 155 36 170 C36 185 37 198 38 210 L47 210 C47 196 48 182 48 168 L50 140 L52 168 C52 182 53 196 53 210 L62 210 C63 198 64 185 64 170 C65 155 66 140 67 124 C69 112 70 100 70 85 L70 60 L72 70 C74 80 76 92 78 102 L86 100 C85 90 83 76 82 65 C81 55 79 46 75 41 C72 37 64 35 59 33 C58 30 56 27 50 27 Z";

function Figure({ view, marks, onAdd, testId }) {
  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    onAdd({ view, x: Math.round(x * 10) / 10, y: Math.round(y * 10) / 10, note: "" });
  };
  return (
    <div className="text-center">
      <svg data-testid={`${testId}-${view}`} viewBox="0 0 100 220" onClick={handleClick}
        className="mx-auto h-64 w-auto cursor-crosshair rounded-xl border border-[#EFEBE0] bg-white">
        <circle cx="50" cy="16" r="11" fill="none" stroke="#8D6E63" strokeWidth="1.5" />
        <path d={OUTLINE} fill="none" stroke="#8D6E63" strokeWidth="1.5" />
        {view === "back" && <line x1="50" y1="30" x2="50" y2="118" stroke="#D7CCC8" strokeWidth="1" strokeDasharray="3 3" />}
        {marks.map((m) => (
          <g key={m.n}>
            <circle cx={m.x} cy={m.y * 2.2} r="5" fill="#C62828" opacity="0.9" />
            <text x={m.x} y={m.y * 2.2 + 2.2} textAnchor="middle" fontSize="6.5" fontWeight="bold" fill="#fff">{m.n}</text>
          </g>
        ))}
      </svg>
      <div className="mt-1 text-xs font-bold text-[#5D4037]">{view === "front" ? "Front" : "Back"}</div>
    </div>
  );
}

export function BodyMap({ value, onChange, testId = "cf-bodymap" }) {
  const marks = Array.isArray(value) ? value : [];
  const withIdx = marks.map((m, i) => ({ ...m, n: i + 1 }));
  const add = (m) => onChange([...marks, m]);
  const setNote = (i, note) => onChange(marks.map((m, ix) => (ix === i ? { ...m, note } : m)));
  const remove = (i) => onChange(marks.filter((_, ix) => ix !== i));
  return (
    <div data-testid={testId} className="rounded-xl border border-[#EFEBE0] bg-[#FDFCF8] p-4">
      <div className="mb-3 text-xs text-[#7B6157]">Click the figures to mark areas of skin involvement, bruises, injuries, or scars. Each mark gets a numbered note below.</div>
      <div className="mx-auto grid max-w-md grid-cols-2 gap-4">
        <Figure view="front" marks={withIdx.filter((m) => m.view === "front")} onAdd={add} testId={testId} />
        <Figure view="back" marks={withIdx.filter((m) => m.view === "back")} onAdd={add} testId={testId} />
      </div>
      {marks.length > 0 && (
        <div className="mt-3 space-y-1.5" data-testid={`${testId}-notes`}>
          {withIdx.map((m, i) => (
            <div key={i} className="flex items-center gap-2">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#C62828] text-[11px] font-bold text-white">{m.n}</span>
              <span className="shrink-0 text-[11px] font-semibold uppercase text-[#7B6157]">{m.view}</span>
              <input data-testid={`${testId}-note-${i}`} value={m.note || ""} onChange={(e) => setNote(i, e.target.value)}
                placeholder="Describe the finding (e.g., bruise, scar, injection site)…"
                className="w-full rounded-lg border border-[#E5DFD3] px-2.5 py-1.5 text-xs text-[#3E2723] focus:border-[#8D6E63] focus:outline-none" />
              <button type="button" data-testid={`${testId}-remove-${i}`} onClick={() => remove(i)}
                className="shrink-0 rounded-lg p-1.5 text-[#C62828] hover:bg-[#FFEBEE]"><Trash2 size={13} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
